import { createElement } from 'react';
import { f as Breadcrumb$1, _ as __assign } from '../../index.esm-5f955dcb.js';
import 'react-measure';
import 'react-router-dom';
import 'react-dom';
import 'throttle-debounce';
import 'focus-trap-react';
import 'react-swipeable';
import 'react-animate-height';
import 'country-flag-emoji-polyfill';
import 'intersection-observer';
import 'html-react-parser';

var Breadcrumb = function Breadcrumb(props) {
  return /*#__PURE__*/createElement(Breadcrumb$1, __assign({}, props));
};
Breadcrumb.displayName = 'Breadcrumb';

export { Breadcrumb };
